import { Page } from '$core/models/page';
import { Component, Input } from '@angular/core';
import getContrastRatio from 'get-contrast-ratio';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {
  @Input() public item: Page;
  @Input() public extraClass: string;
  @Input() public isFullHeight = false;

  public get img() {
    if (!this.item || !this.item.hero_image) {
      return '';
    }

    return this.item.hero_image.path;
  }

  public get color() {
    if (!this.item || !this.item.hero_image) {
      return '';
    }

    return this.item.hero_image.color;
  }

  public get hasSubstrate(): boolean {
    if (this.color) {
      const ratio = getContrastRatio('white', this.color);
      if (ratio < 4) {
        return true;
      }
    }
    return false;
  }
}
